import { AbstractEntityMapper } from '@pf/shared-services';
import {
    PackingListCreate,
    PackingListDto,
    PackingListRead,
    PackingListSearchParams,
} from '../../entities/packing-list.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { PackingListMetadataMap } from './packing-list.mapping-profile';

@Injectable()
export class PackingListMapper extends AbstractEntityMapper<
    PackingListRead,
    PackingListCreate,
    PackingListDto,
    PackingListSearchParams
> {
    constructor() {
        super(
            PackingListDto,
            PlatformWmsMapper,
            PackingListMetadataMap.symbols
        );
    }
}
